import React from "react";
import AddMoreInput from "./AddMoreInput";
import JobPreview from "./JobPreview";
import { CommonHeader } from "../../commons";
import { ProceduresType } from "../../../commonTypes/jobsType";


type AppProps = {
  history?:any;
  data: ProceduresType;
  title: string;
  setTitle: React.Dispatch<React.SetStateAction<string>>;
  setData: React.Dispatch<React.SetStateAction<ProceduresType>>;
  handleSubmit:()=>void;
  type:string;
  fileData:string;
  setModal:React.Dispatch<React.SetStateAction<boolean>>;
};

const JobChecklistForm = ({ history,data, title, setTitle, setData , handleSubmit , type , setModal, fileData}: AppProps) => {
  return (
    <div>
        <div className="col-md-4 mb-3">
                <CommonHeader title={`${type} Checklist`} />
            </div>
      <div className="m-2 ml-4 d-flex" style={{  gap: "20px" }}>
        {/* left  */}
        <AddMoreInput
          history={history}
          data={data}
          handleSubmit={handleSubmit}
          type={type}
          title={title}
          setTitle={setTitle}
          setData={setData}
          setModal={setModal}
        />

        {/* right  */}
        <JobPreview data={data} title={title} fileData={fileData}/>
      </div>
    </div>
  );
};

export default JobChecklistForm;
